import { Directive, Input } from '@angular/core';
import { FiStateSrefNavigateCheck } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.inject';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypesService } from '@fi-app/utilities/fi-services/object-types.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

export interface IFiStateSrefAccess {
    access: boolean;
    objectType: any;
    isInfoDialog?: boolean;
}

@Directive({
    selector: '[fiStateSrefAccess]',
    providers: [
        {
            provide: FiStateSrefNavigateCheck,
            useFactory: (instance: FiStateSrefAccessDirective) => () => instance.checkAccess(),
            deps: [FiStateSrefAccessDirective],
        },
    ],
    standalone: false,
})
export class FiStateSrefAccessDirective {
    @Input('fiStateSrefAccess') stateSrefAccess?: IFiStateSrefAccess;

    constructor(
        protected fiDialogsService: FiDialogsService,
        protected appTextService: AppTextService,
        protected objectTypesService: ObjectTypesService,
    ) {}

    checkAccess() {
        if (this.stateSrefAccess.access) return true;

        if (this.stateSrefAccess.isInfoDialog) {
            this.showInfoDialog();
            return;
        }

        this.showErrorDialog();
    }

    private showInfoDialog() {
        const headerText: string = this.appTextService.get('common.no_right_to_access_object_info_header', {
            '{object_type}': this.objectTypesService.GetNameByObjectType(this.stateSrefAccess.objectType).toLowerCase(),
        });
        const messageText: string = this.appTextService.get('common.no_right_to_access_object_info_message', {
            '{object_type}': this.objectTypesService.GetNameByObjectType(this.stateSrefAccess.objectType).toLowerCase(),
        });
        this.fiDialogsService.blueInfoDialog({
            headerText,
            messageText,
            config: {
                maxWidth: '560px',
                panelClass: 'fi-rounded-dialog-panel',
                autoFocus: false,
            },
        });
    }

    private showErrorDialog() {
        this.fiDialogsService.error({
            messageText: this.appTextService.get('common.no_right_to_access_object', {
                '{object_type}': this.objectTypesService
                    .GetNameByObjectType(this.stateSrefAccess.objectType)
                    .toLowerCase(),
            }),
        });
    }
}
